<object [data]="getSafeSrc()" type="application/pdf">
    <a [href]="getSafeSrc()" trans>Download the file.</a>
</object>